export default {
  name: 'base-html-tag',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  },
  render (h, {props, data, parent, children, slots}) {
    const newData = Object.assign({attrs: {}}, data)

    return h(props.tag, newData, children)
  }
}
